import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';

// Material UI
import { withStyles } from 'material-ui/styles';

// Styles
import styles from './styles';

// Core Scenes
import Home from '../../scenes/Home';
import Search from '../../scenes/Search';
import Communication from '../../scenes/Communication';
import ServiceLevel from '../../scenes/ServiceLevel';
import MyProfiles from '../../scenes/MyProfiles';
import SpecialServices from '../../scenes/SpecialServices';
import Account from '../../scenes/Account';
import Support from '../../scenes/Support';
import Contact from '../../scenes/Contact';
import LogOut from '../../scenes/LogOut';
import User from '../../scenes/User';
import AllCommunication from '../../scenes/AllCommunication';
import SubmitBug from '../../scenes/SubmitBug';
import OARReport from '../../scenes/OARReport';

class CoreContent extends Component {
  render(){
    const { classes, location} = this.props;
    return(
      <main className={classes.content}>
        <ConnectedSwitch>
          <Route exact path='/console' location={this.props.location} component={Home}/>
          <Route path='/console/display' location={this.props.location} component={Home}/>
          <Route path='/console/search' location={this.props.location} component={Search}/>
          <Route path='/console/my_profiles' location={this.props.location} component={MyProfiles}/>
          <Route path='/console/communication' location={this.props.location} component={Communication}/>
          <Route path='/console/special_services' location={this.props.location} component={SpecialServices}/>
          <Route path='/console/service_level' location={this.props.location} component={ServiceLevel}/>
          <Route path='/console/profile' location={this.props.location} component={Account}/>
          <Route path='/console/support' location={this.props.location} component={Support}/>
          <Route path='/console/contact' location={this.props.location} component={Contact}/>
          <Route path='/console/logout' location={this.props.location} component={LogOut}/>
          <Route path='/console/user' location={this.props.location} component={User}/>
          <Route path='/console/submit_bug' location={this.props.location} component={SubmitBug}/>
          <Route path='/console/all_communication' location={this.props.location} component={AllCommunication}/>
          <Route path='/console/oarreport' location={this.props.location} component={OARReport}/>
        </ConnectedSwitch>
      </main>
    );
  }
}

CoreContent.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const ConnectedSwitch = connect(state => ({
  location: state.location
}))(Switch)

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(CoreContent)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CoreContent/index.js